import { Uploader } from "../../../components/custom/uploader";
import { cn } from "../../../utils/utils";
import UploadIcon from "../../assets/svgs/upload.svg";
import { useState, useEffect } from "react";
import CrossIcon from "../../assets/svgs/cross.svg";

type ImageUploaderProps = {
  className?: string;
  onChange: (files: File[]) => void;
  value?: File[];
  name?: string;
  label?: string;
};

export const ImageUploader = ({
  className,
  onChange,
  value = [],
  name,
  label,
}: ImageUploaderProps) => {
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (value && value.length > 0) {
      const url = URL.createObjectURL(value[0]);
      setPreview(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreview(null);
  }, [value]);

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange([]);
  };

  return (
    <div className="flex flex-col gap-2 font-cabinetgrotesk text-sm">
      <label htmlFor={name} className="w-full md:font-medium md:text-lg">
        {label}
      </label>
      <div className={cn("relative", className)}>
        {preview ? (
          <div className="relative rounded-xl w-full h-full">
            <img
              src={preview}
              alt="Brand Logo"
              className="rounded-xl w-full h-full object-cover"
            />
            <button
              type="button"
              onClick={handleRemove}
              className="-top-2 -right-2 absolute bg-white p-0.5 rounded-full"
            >
              <CrossIcon />
            </button>
          </div>
        ) : (
          <Uploader
            accept={{
              "image/jpg": [],
              "image/jpeg": [],
              "image/png": [],
            }}
            maxFiles={1}
            multiple={false}
            maxSize={5 * 1024 * 1024}
            value={value}
            onValueChange={onChange}
            className={cn(
              "flex flex-col items-center justify-center gap-2  border border-border rounded-xl  font-semibold text-secondary cursor-pointer",
              className
            )}
          >
            <UploadIcon />
          </Uploader>
        )}
      </div>
    </div>
  );
};
